import React from 'react';
import {Box} from '@mui/material';
import './SearchListItem.scss';
import {SessionSearch} from '../../types/SessionSearch';
import NewItem from './new-item/NewItem';
import ExistingItem from './existing-item/ExistingItem';

export interface SearchListItemProps {
  index: number;
  item: SessionSearch;
  canPin?: boolean;
  onSelect?: (index: number, item: SessionSearch) => void;
  onPin?: (index: number, item: SessionSearch) => void;
  onUnpin?: (index: number, item: SessionSearch) => void;
  onDelete?: (index: number, item: SessionSearch) => void;
}

const SearchListItem: React.FC<SearchListItemProps> = (props) => {
  const index = props.index;
  const item = props.item;
  const onItemSelected = props.onSelect;
  const listItemClassName = `session-search-list-item list-item-${index} ${item.isSelected ? 'active' : ''}`;

  const handleOnClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    onItemSelected && onItemSelected(index, item);
  };

  const handleOnKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.code === 'Enter') {
      e.stopPropagation();
      onItemSelected && onItemSelected(index, item);
    }
  };

  const renderItem = () => {
    if (item.lastRuntime || item.isSaved) {
      return <ExistingItem {...props}></ExistingItem>;
    } else {
      return <NewItem {...props}></NewItem>;
    }
  };

  return (
    <Box
      className={listItemClassName}
      sx={{
        borderColor: item.color,
      }}
      data-testid={`session-search-item-${index}`}
      tabIndex={0}
      role="listitem"
      aria-labelledby={`session-search-item-${index}`}
      onClick={handleOnClick}
      onKeyDown={handleOnKeyDown}
    >
      {renderItem()}
    </Box>
  );
};
export default SearchListItem;
